module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/459.fa94bc07.png";